var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"progress",staticClass:"zlr-progress",class:[_vm.isStick? 'zlr-progress-stick': '']},[_c('div',{staticClass:"zlr-progress-in",class:[_vm.typeColor ===1?'zlr-progress-green':''],style:({width: Math.floor(_vm.percent)+'%'})})])}
var staticRenderFns = []

export { render, staticRenderFns }